import React, { useEffect, useState } from 'react';
import { Paper, Table, TableCell, TableContainer, TableRow, Button, Typography } from '@material-ui/core';
import useStyles from '@jumbo/components/Mantenimiento/MantenimientoStyle';
import NoRecordFound from '@jumbo/components/ListadoEjecucion/NoRecordFound';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import { getComparator, stableSort } from '@jumbo/utils/tableHelper';
import Toolbar from '@material-ui/core/Toolbar';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableUtils from '@jumbo/utils/TableUtils';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTTToDiasHabiles,
  getTiposFacturacion,
  GrabarDiasHabiles,
  EliminarDiasHabiles,
  getFormaPago,
  getCARGARESERVAEXTRAFINSEMANA,
  GET_PAYCONDITION,
} from '../../redux/actions/Mantenimiento';
import TextField from '@material-ui/core/TextField';
import Autocompetesinapp from '../Ejecucion/utils/Autocompetesinapp';
import { ValorSelect } from 'routes/Ejecucion/utils/Helper';
import Swal from 'sweetalert2';
import ReactExport from 'react-export-excel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const headCells = [
  {
    id: 'tourOp',
    numeric: false,
    disablePadding: false,
    label: 'Tour Operador',
  },
  {
    id: 'payCond',
    numeric: false,
    disablePadding: false,
    label: 'Condición de Pago',
  },
  {
    id: 'creditDays',
    numeric: false,
    disablePadding: false,
    label: 'Días PP/CR',
  },
  {
    id: 'diasHabil',
    numeric: false,
    disablePadding: false,
    label: 'Días Hábiles',
  },
  {
    id: 'tipoFacturacion',
    numeric: false,
    disablePadding: false,
    label: 'Tipo de Cobro',
  },
  {
    id: 'formaPago',
    numeric: false,
    disablePadding: false,
    label: 'Forma de Pago',
  },
  {
    id: 'cargaReservaExtranetFinSemana',
    numeric: false,
    disablePadding: false,
    label: 'Cargas Reservas Extranet C/O Fin de Semana  ',
  },
  {
    id: 'semana1',
    numeric: false,
    disablePadding: false,
    label: 'Semana 1',
  },
  {
    id: 'semana2',
    numeric: false,
    disablePadding: false,
    label: 'Semana 2',
  },
  {
    id: 'semana3',
    numeric: false,
    disablePadding: false,
    label: 'Semana 3',
  },
  {
    id: 'semana4',
    numeric: false,
    disablePadding: false,
    label: 'Semana 4',
  },
  {
    id: 'semana5',
    numeric: false,
    disablePadding: false,
    label: 'Semana 5',
  },
];

function TableHeadFormulario({ classes, order, orderBy, onRequestSort }) {
  const onSortOrderChange = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={onSortOrderChange(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align="right">Acción</TableCell>
      </TableRow>
    </TableHead>
  );
}

export default function PlantillasForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ttoodiashabiles, tiposdefacturacion, FormaPago, CargaReservaExtraFinSemana, PayCondition } = useSelector(
    ({ mantenimiento }) => mantenimiento,
  );
  const [data, setData] = useState([]);
  const [orderBy, setOrderBy] = React.useState('descripcion');
  const [order, setOrder] = React.useState('asc');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [diashabiles, setdiashabiles] = useState('');
  const [tipoFacturacionTTOOID, settipoFacturacionTTOOID] = useState('-10000');
  const [FormaPagoGenID, setFormaPagoGenID] = useState('-10000');
  const [CargaReservaExtranetFinSemanaGenID, setCargaReservaExtranetFinSemanaGenID] = useState('-10000');
  const [Semana1, setSemana1] = useState(false);
  const [Semana2, setSemana2] = useState(false);
  const [Semana3, setSemana3] = useState(false);
  const [Semana4, setSemana4] = useState(false);
  const [Semana5, setSemana5] = useState(false);
  const [formApp, setformApp] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [formStateFiltros, setFformStateFiltros] = useState({
    tourOpID: -10000,
    payCondId: 'NA',
    creditDays: null,
    diasHabil: null,
    formaPagoGenID: -10000,
    cargaReservaExtranetFinSemanaGenID: -10000,
    TipoFacturacionTTOOID: -10000,
  });

  useEffect(() => {
    dispatch(getTTToDiasHabiles(formStateFiltros));
    dispatch(getTiposFacturacion());
    dispatch(getFormaPago());
    dispatch(getCARGARESERVAEXTRAFINSEMANA());
    dispatch(GET_PAYCONDITION());
  }, [dispatch]);

  useEffect(() => {
    const filtrosNormalizados = {
      ...formStateFiltros,
      creditDays: formStateFiltros.creditDays === '' ? null : formStateFiltros.creditDays,
      diasHabil: formStateFiltros.diasHabil === '' ? null : formStateFiltros.diasHabil,
    };

    dispatch(getTTToDiasHabiles(filtrosNormalizados));
  }, [formStateFiltros]);

  useEffect(() => {
    function getFilteredArray(entities, _searchTerm) {
      if (_searchTerm.length === 0) {
        return ttoodiashabiles;
      }
      return TableUtils.filterArrayByString(ttoodiashabiles, _searchTerm);
    }
    if (ttoodiashabiles) {
      setData(getFilteredArray(ttoodiashabiles, searchTerm));
    }
  }, [ttoodiashabiles, searchTerm]);

  const handleCloseDialog = () => {
    setformApp('');
    setdiashabiles('');
    settipoFacturacionTTOOID('-10000');
    setFormaPagoGenID('-10000');
    setCargaReservaExtranetFinSemanaGenID('-10000');
    setSemana1(false);
    setSemana2(false);
    setSemana3(false);
    setSemana4(false);
    setSemana5(false);
    setOpenDialog(false);
  };

  const handleOpenDialog = formAppdata => {
    setformApp(formAppdata);
    setdiashabiles(formAppdata.diasHabil);
    settipoFacturacionTTOOID(formAppdata.tipoFacturacionTTOOID);
    setFormaPagoGenID(formAppdata.formaPagoGenID);
    setCargaReservaExtranetFinSemanaGenID(formAppdata.cargaReservaExtranetFinSemanaGenID);
    setSemana1(formAppdata.semana1);
    setSemana2(formAppdata.semana2);
    setSemana3(formAppdata.semana3);
    setSemana4(formAppdata.semana4);
    setSemana5(formAppdata.semana5);
    setOpenDialog(true);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrderBy(property);
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <PageContainer heading="Condición de Pago">
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Toolbar style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h4" id="tableTitle" component="div" style={{ whiteSpace: 'nowrap' }}>
              Listado de Tours Operadores
            </Typography>

            <div style={{ marginLeft: 'auto' }}>
              <ExcelFile
                element={
                  <Button variant="contained" color="secondary">
                    Exportar Excel
                  </Button>
                }>
                <ExcelSheet data={ttoodiashabiles} name="Condiciones de pago">
                  <ExcelColumn label="tourOp" value="tourOp" />
                  <ExcelColumn label="Pay Condicion" value="payCond" />
                  <ExcelColumn label="Credit Days" value="creditDays" />
                  <ExcelColumn label="Dias Habil" value="diasHabil" />
                  <ExcelColumn label="Tipo de Cobro" value="tipoFacturacion" />
                  <ExcelColumn label="Forma de Pago" value="formaPago" />
                  <ExcelColumn label="Cargas Reservas Extranet C/O Fin de Semana" value="cargaReservaExtranetFinSemana" />
                  <ExcelColumn label="Semana 1" value="semana1" />
                  <ExcelColumn label="Semana 2" value="semana2" />
                  <ExcelColumn label="Semana 3" value="semana3" />
                  <ExcelColumn label="Semana 4" value="semana4" />
                  <ExcelColumn label="Semana 5" value="semana5" />
                </ExcelSheet>
              </ExcelFile>
            </div>
          </Toolbar>

          <Toolbar>
            <TextField
              fullWidth
              label="Tour Operador"
              variant="outlined"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              size="small"
            />
          </Toolbar>

          <Toolbar
            className={classes.roottoolbar}
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '12px',
              marginBottom: '12px',
            }}>
            <Autocompetesinapp
              options={PayCondition}
              value={PayCondition.find(x => x.value === formStateFiltros.payCondId.toString())}
              name="Condición de Pago"
              onChange={(e, newValue) =>
                setFformStateFiltros(prev => ({ ...prev, payCondId: ValorSelect(newValue) ?? 'NA' }))
              }
              fullWidth
            />

            <TextField
              fullWidth
              label="Días PP/CR"
              variant="outlined"
              value={formStateFiltros.creditDays ?? ''}
              onChange={e => {
                const value = e.target.value;
                setFformStateFiltros(prev => ({
                  ...prev,
                  creditDays: value === '' ? null : value,
                }));
              }}
              size="small"
            />

            <TextField
              fullWidth
              label="Días Hábiles"
              variant="outlined"
              value={formStateFiltros.diasHabil ?? ''}
              onChange={e => {
                const value = e.target.value;
                setFformStateFiltros(prev => ({
                  ...prev,
                  diasHabil: value === '' ? null : value,
                }));
              }}
              size="small"
            />
            <Autocompetesinapp
              options={tiposdefacturacion}
              value={tiposdefacturacion.find(x => x.value === formStateFiltros.TipoFacturacionTTOOID.toString())}
              name="Tipo de Cobro"
              onChange={(e, newValue) =>
                setFformStateFiltros(prev => ({ ...prev, TipoFacturacionTTOOID: ValorSelect(newValue) ?? '-10000' }))
              }
              fullWidth
            />

            <Autocompetesinapp
              options={FormaPago ?? []}
              value={FormaPago.find(x => x.value === formStateFiltros.formaPagoGenID.toString())}
              name="Forma de Pago"
              onChange={(e, newValue) =>
                setFformStateFiltros(prev => ({ ...prev, formaPagoGenID: ValorSelect(newValue) ?? '-10000' }))
              }
              fullWidth
            />

            <Autocompetesinapp
              options={CargaReservaExtraFinSemana ?? []}
              value={CargaReservaExtraFinSemana.find(
                x => x.value === formStateFiltros.cargaReservaExtranetFinSemanaGenID.toString(),
              )}
              name="Cargas Reservas Extranet C/O Fin de Semana  "
              onChange={(e, newValue) =>
                setFformStateFiltros(prev => ({
                  ...prev,
                  cargaReservaExtranetFinSemanaGenID: ValorSelect(newValue) ?? '-10000',
                }))
              }
              fullWidth
            />
          </Toolbar>

          <TableContainer className={classes.container}>
            <Table stickyHeader className={classes.table} aria-labelledby="tableTitle" aria-label="sticky enhanced table">
              <TableHeadFormulario classes={classes} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />

              <TableBody>
                {!!data.length ? (
                  stableSort(data, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow hover tabIndex={-1} key={row.formAppID}>
                        <TableCell>{row.tourOp}</TableCell>
                        <TableCell>{row.payCond}</TableCell>
                        <TableCell>{row.creditDays}</TableCell>
                        <TableCell>{row.diasHabil}</TableCell>
                        <TableCell>{row.tipoFacturacion}</TableCell>
                        <TableCell>{row.formaPago}</TableCell>
                        <TableCell>{row.cargaReservaExtranetFinSemana}</TableCell>
                        <TableCell>{row.semana1 ? 'Si' : 'No'}</TableCell>
                        <TableCell>{row.semana2 ? 'Si' : 'No'}</TableCell>
                        <TableCell>{row.semana3 ? 'Si' : 'No'}</TableCell>
                        <TableCell>{row.semana4 ? 'Si' : 'No'}</TableCell>
                        <TableCell>{row.semana5 ? 'Si' : 'No'}</TableCell>
                        <TableCell align="right">
                          <Button
                            size="small"
                            style={{ marginRight: 5 }}
                            className={classes.button}
                            variant="contained"
                            color="secondary"
                            onClick={() => handleOpenDialog(row)}>
                            Editar
                          </Button>
                          <Button
                            size="small"
                            className={classes.buttonerror}
                            variant="contained"
                            onClick={() => {
                              Swal.fire({
                                title: '¿Estás seguro(a) de Eliminar?',
                                text: '¡No podrás recuperar este cambio!',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: 'red',
                                confirmButtonText: 'Si, Eliminar',
                                cancelButtonText: 'No, Mantener',
                              }).then(result => {
                                if (result.value) {
                                  dispatch(EliminarDiasHabiles(row.tourOpDiasHabilID, formStateFiltros));
                                } else if (result.dismiss === Swal.DismissReason.cancel) {
                                  Swal.fire('Cancelado', 'No se realizó este cambio :)', 'error');
                                }
                              });
                            }}>
                            Eliminar
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow style={{ height: 53 * 6 }}>
                    <TableCell colSpan={7} rowSpan={10}>
                      <NoRecordFound>No se han encontrado registros.</NoRecordFound>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            labelRowsPerPage="Filas por página"
          />
        </Paper>
      </div>
      <>
        <Dialog open={openDialog} className={classes.dialogRoot} fullWidth maxWidth="sm">
          <DialogTitle className={classes.dialogTitleRoot}> Editar Plantilla </DialogTitle>
          <DialogContent dividers>
            <div className={classes.root}>
              <TextField
                className={classes.textlabel}
                fullWidth
                label="Días Hábiles"
                variant="outlined"
                value={diashabiles}
                onChange={value => setdiashabiles(value.target.value)}
                size="small"
                style={{ marginBottom: 10 }}
              />
              <div style={{ marginBottom: 10 }}>
                {tiposdefacturacion.length > 0 && (
                  <Autocompetesinapp
                    options={tiposdefacturacion}
                    value={tiposdefacturacion.find(x => x.value === tipoFacturacionTTOOID.toString())}
                    name="Tipo de Cobro"
                    onChange={(event, newValue) => {
                      settipoFacturacionTTOOID(ValorSelect(newValue) ?? '-10000');
                    }}
                    fullWidth
                  />
                )}
              </div>
              <div style={{ marginBottom: 10 }}>
                {FormaPago.length > 0 && (
                  <Autocompetesinapp
                    options={FormaPago}
                    value={FormaPago.find(x => x.value === FormaPagoGenID.toString())}
                    name="Forma de Pago"
                    onChange={(event, newValue) => {
                      setFormaPagoGenID(ValorSelect(newValue) ?? '-10000');
                    }}
                    fullWidth
                  />
                )}
              </div>
              <div style={{ marginBottom: 10 }}>
                {CargaReservaExtraFinSemana.length > 0 && (
                  <Autocompetesinapp
                    options={CargaReservaExtraFinSemana}
                    value={CargaReservaExtraFinSemana.find(x => x.value === CargaReservaExtranetFinSemanaGenID.toString())}
                    name="Cargas Reservas Extranet C/O Fin de Semana  "
                    onChange={(event, newValue) => {
                      setCargaReservaExtranetFinSemanaGenID(ValorSelect(newValue) ?? '-10000');
                    }}
                    fullWidth
                  />
                )}
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Semana1}
                      onChange={() => setSemana1(!Semana1)}
                      inputProps={{ 'aria-label': 'Semana1' }}
                    />
                  }
                  label="Semana 1"
                />
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Semana2}
                      onChange={() => setSemana2(!Semana2)}
                      inputProps={{ 'aria-label': 'Semana2' }}
                    />
                  }
                  label="Semana 2"
                />
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Semana3}
                      onChange={() => setSemana3(!Semana3)}
                      inputProps={{ 'aria-label': 'Semana3' }}
                    />
                  }
                  label="Semana 3"
                />
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Semana4}
                      onChange={() => setSemana4(!Semana4)}
                      inputProps={{ 'aria-label': 'Semana4' }}
                    />
                  }
                  label="Semana 4"
                />
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Semana5}
                      onChange={() => setSemana5(!Semana5)}
                      inputProps={{ 'aria-label': 'Semana5' }}
                    />
                  }
                  label="Semana 5"
                />
              </div>
            </div>
            <Box display="flex" justifyContent="flex-end" my={4}>
              <Button variant="contained" onClick={handleCloseDialog}>
                Cancelar
              </Button>
              <Box ml={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    dispatch(
                      GrabarDiasHabiles(
                        {
                          TourOpID: formApp.tourOpID,
                          TipoFacturacionTTOOID: tipoFacturacionTTOOID ?? '-10000',
                          DiasHabil: diashabiles ?? null,
                          FormaPagoGenID: FormaPagoGenID ?? '-10000',
                          CargaReservaExtranetFinSemanaGenID: CargaReservaExtranetFinSemanaGenID ?? '-10000',
                          Semana1: Semana1 ?? false,
                          Semana2: Semana2 ?? false,
                          Semana3: Semana3 ?? false,
                          Semana4: Semana4 ?? false,
                          Semana5: Semana5 ?? false,
                        },
                        handleCloseDialog,
                        formStateFiltros,
                      ),
                    );
                  }}>
                  Guardar
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </>
    </PageContainer>
  );
}
